import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-side-compressed',
  templateUrl: './side-compressed.component.html',
  styleUrl: './side-compressed.component.scss'
})
export class SideCompressedComponent implements AfterViewInit {
  @ViewChild('sidecompressed') sidecompressed!: ElementRef<HTMLDivElement>;
  @ViewChild('sidecompressedinformation') sidecompressedinformation!: ElementRef<HTMLDivElement>;

  @Input() minHeight: number = 50;
  @Input() expandContent: boolean = false;

  ngAfterViewInit(): void {
    this.sidecompressed.nativeElement.style.height = !this.expandContent ?
      `${this.minHeight}px`
      : `${this.sidecompressedinformation.nativeElement.offsetHeight}px`;
  }

  showInformation() {
    this.expandContent = !this.expandContent;
    this.sidecompressed.nativeElement.style.height = `${!this.expandContent ?
      this.minHeight
      : this.sidecompressedinformation.nativeElement.offsetHeight}px`;
  }

  get titlebtn(): string {
    return this.expandContent ? '-' : '+';
  }
}
